import { useEffect, useState } from "react";
import { Login, useTheme } from "react-admin";
import Config from "../../config";
import techniklagerLogo from "../../imgs/logo-light.png";
import medientechnikLogo from "../../imgs/logo-light.png";

export const LoginPage = () => {
    const [logo, setLogo] = useState(null);
    const [mandantName, setMandantName] = useState("Loading...");
    const [theme, setTheme] = useTheme();

    useEffect(() => {
        const cfg = new Config();
        let mounted = true;

        (async () => {
            try {
                const name = await cfg.getAsync("mandantName");
                const initials = await cfg.getAsync("mandantInitials");

                if (mounted) {
                    setLogo(initials === "MT" ? medientechnikLogo : techniklagerLogo);
                    setMandantName(name);
                }
            } catch (err) {
                console.error("Failed to load config:", err);
            }
        })();

        return () => {
            mounted = false;
        };
    }, []);

    return (
        <Login
            sx={{
                "& .RaLogin-avatar": {
                    mb: 0,
                },
                "& .RaLogin-icon": {
                    borderRadius: 0,
                    paddingTop: 8,
                    paddingBottom: 9,
                    paddingLeft: 16,
                    paddingRight: 16,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    backgroundColor: "transparent",
                },
                "& .RaLogin-icon img": {
                    width: 40,
                    height: 40,
                    objectFit: "contain",
                    display: "block",
                },
                "& .app-title": {
                    fontSize: 16,
                    fontWeight: 600,
                    color: theme === "dark" ? "#fff" : "#000",
                    textAlign: "center",
                },
                "& .login-mandant": {
                    fontFamily: "Maven Pro, sans-serif",
                    fontSize: 16,
                    color: theme === "dark" ? "#fff" : "#000",
                    textAlign: "center",
                },
            }}
            avatarIcon={
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "16px",
                    }}
                >
                    {<img src={logo} alt="logo" />}
                    {<div className="app-title">eQuip</div>}
                    {mandantName && (
                        <div className="login-mandant">{mandantName.toUpperCase()}</div>
                    )}
                </div>
            }
        />
    );
};
